export default __webpack_public_path__ + "static/media/n1.378a7f02.jpg";